/* eslint-disable @typescript-eslint/naming-convention */
import { FormFieldInterface } from 'app/components/form-builder/form-builder.interface';

export class SDKFormSerializer {
    fields: Array<FormFieldInterface>;
    fieldMap: any = {};

    constructor(formConfig: any) {
        this.fields = this._serializeFields(formConfig);
    }

    deSerializeCheckList(data: any): any {
        const deserialzedData = {};
        data.forEach((item: any) => {
            if (item.type !== 'HEADER') {
                deserialzedData[this.fieldMap[item.question]] = item.answer;
            }
        });
        return deserialzedData;
    }

    private _serializeFields(formConfig: any[]): Array<FormFieldInterface> {
        // serialize form config to support formfieldinterface with default values.
        return formConfig.map((fieldConfig: any) => {
            this.fieldMap[fieldConfig.label] = fieldConfig.id;
            const field: any = {
                field_type: fieldConfig.type,
                field_name: fieldConfig.label,
                field_value: fieldConfig.default || null,
                field_placeholder: fieldConfig.placeholder || null,
                field_description: fieldConfig.description,
                field_options: fieldConfig.values || [],
                is_deleted: false,
                is_required: false,
                original_template: {},
                formControlName: fieldConfig.label,
                group: 'DEFAULT',
                width: fieldConfig.type === 'HEADER' ? 'col-span-3' : 'col-span-1'
            };
            if (field.field_type === 'SINGLE_ITEM' || field.field_type === 'MULTI_ITEM'){
                field.is_options_object  = typeof field.field_options[0] === 'object';
                if(field.is_options_object){
                    field.option_label = fieldConfig.option_label;
                    field.option_value = fieldConfig.option_value;
                }
            }
            if (fieldConfig.field_options) {
                field.is_required = fieldConfig.field_options.is_required || false;
                field.max_value = fieldConfig.field_options.max_value || null;
                field.min_value = fieldConfig.field_options.min_value || null;
                field.hide_field = fieldConfig.field_options.hidden || false;
                field.read_only = fieldConfig.field_options.read_only || false;
                field.width = fieldConfig.field_options.width || 'col-span-1';
                field.show_custom_error = field.show_custom_error || false;
                field.custom_error_message = fieldConfig.field_options.custom_error_message || null;
                field.original_template = {
                    max_value: field.max_value,
                    min_value: field.min_value,
                };
            }
            return field;
        });
    }


}

